(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fm-drop-signup"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.fm-drop-signup').forEach(wrapper=>{const result=wrapper.querySelector('.fm-drop-success,.fm-drop-error');if(result){wrapper.querySelector('details').open=true;}if(location.hash==='#'+wrapper.id){wrapper.querySelector('details').open=true;}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fm-legal-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fm-legal-notice')) {
  customElements.define('fm-legal-notice', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openFromLink = event => {
        const trigger = event.target.closest('[data-fm-open-rights]');
        if (!trigger || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.dialog.showModal();
      };
      document.addEventListener('click', this.openFromLink);
      this.querySelector('[data-close-rights]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
    }
    disconnectedCallback() { document.removeEventListener('click', this.openFromLink); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fm-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fm-product-gallery')) {
    customElements.define('fm-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.fm-gallery-track');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;
        this.addEventListener('click', event => {
          const thumb = event.target.closest('[data-gallery-thumb]');
          if (thumb) this.go(Number(thumb.dataset.galleryThumb));
          else if (event.target.closest('[data-gallery-next]')) this.go(this.index + 1);
          else if (event.target.closest('[data-gallery-previous]')) this.go(this.index - 1);
        }, options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const destinations = { ArrowRight: this.index + 1, ArrowLeft: this.index - 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in destinations)) return;
          event.preventDefault();
          this.go(destinations[event.key]);
        }, options);
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (this.track.clientWidth > 0) this.update(Math.round(this.track.scrollLeft / this.track.clientWidth));
          });
        }, { ...options, passive: true });
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft, index: this.index };
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
          event.preventDefault();
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          this.track.scrollLeft = this.drag.scroll + this.drag.x - event.clientX;
        }, options);
        const endDrag = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const drag = this.drag;
          this.drag = null;
          const distance = this.track.scrollLeft - drag.scroll;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
          const steps = Math.abs(distance) > 35 ? Math.sign(distance) * Math.max(1, Math.round(Math.abs(distance) / this.track.clientWidth)) : 0;
          this.go(event.type === 'pointercancel' ? this.index : drag.index + steps);
        };
        this.track.addEventListener('pointerup', endDrag, options);
        this.track.addEventListener('pointercancel', endDrag, options);
        this.track.addEventListener('lostpointercapture', endDrag, options);
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.go(this.index, false));
          this.resize.observe(this.track);
        }
        this.update(0);
      }
      go(index, smooth = true) {
        if (this.track.clientWidth <= 0 || !Number.isFinite(index)) return;
        const destination = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({ left: destination * this.track.clientWidth, behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      }
      update(index) {
        if (!Number.isFinite(index)) return;
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.querySelector('[data-gallery-count]').textContent = String(this.index + 1);
        this.querySelector('[data-gallery-previous]').disabled = this.index === 0;
        this.querySelector('[data-gallery-next]').disabled = this.index === this.slides.length - 1;
        this.thumbs.forEach((thumb, number) => thumb.setAttribute('aria-pressed', String(number === this.index)));
        const thumb = this.thumbs[this.index];
        const row = this.querySelector('.fm-gallery-thumbnails');
        if (thumb && row) {
          const box = thumb.getBoundingClientRect();
          const bounds = row.getBoundingClientRect();
          if (box.left < bounds.left) row.scrollLeft -= bounds.left - box.left;
          else if (box.right > bounds.right) row.scrollLeft += box.right - bounds.right;
        }
      }
      disconnectedCallback() {
        if (this.track) this.track.classList.remove('is-dragging');
        if (this.abort) this.abort.abort();
        if (this.resize) this.resize.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.drag = null;
        this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fm-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = JSON.parse(document.getElementById('fm-config').textContent);
  const root = config.root;
  const money = cents => new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency}).format(cents / 100);
  const t = (key, vars={}) => Object.entries(vars).reduce((s,[k,v]) => s.replaceAll('['+k+']', String(v)), config.text[key] || key);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const api = async (path, body) => {
    const res = await fetch(root + path, {method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || t('error'));
    return data;
  };
  let dialog, cartBody;
  let latestCart = {items:[]};
  let cartBusy = false;
  let cartQueue = Promise.resolve();
  const route = path => root+path;
  function updateCartRecommendations(cart) {
    const selected = new Set(cart.items.map(item=>String(item.product_id)));
    document.querySelectorAll('[data-cart-recommendations]').forEach(section=>{
      const rail=section.querySelector('[data-cart-recommendation-rail]');
      const offset=rail.scrollLeft;
      const cards=section.querySelector('template').content.cloneNode(true);
      cards.querySelectorAll('[data-cart-suggestion]').forEach(card=>{
        if(selected.has(card.dataset.productId))card.remove();else{
          card.hidden=false;
          const unit=card.querySelector('[data-recommendation-unit-price]');
          if(unit&&!unit.textContent.trim()&&config.sprayIds.includes(card.dataset.productId))unit.textContent=money(Math.round(Number(card.dataset.price)*1000/30))+' / l';
        }
      });
      rail.replaceChildren(cards);
      section.hidden=!cart.item_count||!rail.querySelector('[data-cart-suggestion]');
      rail.scrollLeft=offset;
    });
  }
  function shippingState(cart, element=dialog) {
    const threshold=Number(element.dataset.shippingThreshold)||0;
    if(element.dataset.shippingEnabled!=='true'||config.currency!=='EUR'||!threshold)return null;
    const remaining=Math.max(0,threshold-cart.total_price);
    const remainingText=element.dataset.shippingRemaining||t('shipping_remaining');
    const reachedText=element.dataset.shippingReached||t('shipping_reached');
    return {text:remaining?remainingText.replaceAll('[amount]',money(remaining)):reachedText,percent:Math.min(100,Math.max(0,cart.total_price/threshold*100))};
  }
  function cartUnitPrice(item) {
    const measurement=item.unit_price_measurement;
    if(measurement&&typeof item.unit_price==='number')return money(item.unit_price)+' / '+(Number(measurement.reference_value)!==1?measurement.reference_value:'')+measurement.reference_unit;
    if(String(item.product_id)==='15938690384212')return money(Math.round(item.final_price*1000/120))+' / l';
    if(config.sprayIds.includes(String(item.product_id)))return money(Math.round(item.final_price*1000/30))+' / l';
    return '';
  }
  function cartIdentity(item) {
    return JSON.stringify([String(item.variant_id),String(item.selling_plan_allocation?.selling_plan?.id||''),Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b))]);
  }
  function cartLine(item, page=false) {
    const unitPrice=cartUnitPrice(item);
    const variant=item.variant_title&&item.variant_title!=='Default Title'?`<p class="fm-note">${esc(item.variant_title)}</p>`:'';
    const properties=Object.entries(item.properties||{}).filter(([key,value])=>!key.startsWith('_')&&value).map(([key,value])=>`<p class="fm-note">${esc(key)}: ${esc(value)}</p>`).join('');
    const controls=page?`<label>${esc(t('quantity'))} <input type="number" name="updates[]" data-cart-page-key="${esc(item.key)}" data-server-quantity="${item.quantity}" value="${item.quantity}" min="0" aria-label="${esc(t('quantity_named',{title:item.product_title}))}"></label>`:`<div class="fm-stepper"><button type="button" data-cart-change="${esc(item.key)}" data-cart-identity="${esc(cartIdentity(item))}" data-cart-variant="${item.variant_id}" data-cart-plan="${item.selling_plan_allocation?.selling_plan?.id||''}" data-cart-action="less" data-quantity="${item.quantity-1}" aria-label="${esc(t('less_named',{title:item.product_title}))}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${esc(item.key)}" data-cart-identity="${esc(cartIdentity(item))}" data-cart-variant="${item.variant_id}" data-cart-plan="${item.selling_plan_allocation?.selling_plan?.id||''}" data-cart-action="more" data-quantity="${item.quantity+1}" aria-label="${esc(t('more_named',{title:item.product_title}))}">+</button></div>`;
    return `<article class="fm-cart-line"><a href="${esc(item.url)}">${item.image?`<img src="${esc(item.image)}" alt="${esc(item.product_title)}" width="80" height="94" loading="lazy">`:''}</a><div><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3>${variant}${properties}${item.selling_plan_allocation&&item.properties?._fm_prepaid==='true'?`<p class="fm-note fm-prepaid-note">${esc(config.prepaidNote)}</p>`:''}${item.selling_plan_allocation?`<p class="fm-note">${esc(item.selling_plan_allocation.selling_plan.name)}</p>`:''}<p class="fm-cart-price-each">${esc(money(item.final_price))} ${esc(t('price_each'))}</p>${unitPrice?`<p class="fm-cart-unit-price">${esc(unitPrice)}</p>`:''}${(item.line_level_discount_allocations||[]).map(d=>`<p class="fm-savings">${esc(d.discount_application.title)}</p>`).join('')}${controls}<button type="button" class="fm-remove" data-cart-change="${esc(item.key)}" data-cart-identity="${esc(cartIdentity(item))}" data-cart-variant="${item.variant_id}" data-cart-plan="${item.selling_plan_allocation?.selling_plan?.id||''}" data-cart-action="remove" data-quantity="0">${esc(t('remove'))}</button></div><strong>${item.original_line_price!==item.final_line_price?`<s>${esc(money(item.original_line_price))}</s>`:''}${esc(money(item.final_line_price))}</strong></article>`;
  }
  function cartMixPanel(cart) { return ''; }
  function updateCartPage(cart, replaceLines=true) {
    document.querySelectorAll('[data-cart-page]').forEach(page=>{
      page.querySelector('[data-cart-page-empty]').hidden=!!cart.item_count;
      page.querySelector('[data-cart-page-form]').hidden=!cart.item_count;
      if(replaceLines){
        const pending=new Map(Array.from(page.querySelectorAll('[data-cart-page-key]')).filter(input=>input.value!==input.dataset.serverQuantity).map(input=>[input.dataset.cartPageKey,input.value]));
        page.querySelector('[data-cart-page-lines]').innerHTML=cart.items.map(item=>cartLine(item,true)).join('');
        page.querySelectorAll('[data-cart-page-key]').forEach(input=>{if(pending.has(input.dataset.cartPageKey))input.value=pending.get(input.dataset.cartPageKey);});
      }
      page.querySelector('[data-cart-page-total]').textContent=money(cart.total_price); const mixPanel=page.querySelector('[data-cart-mix-panel]');if(mixPanel)mixPanel.innerHTML=cartMixPanel(cart);
      page.querySelector('[data-cart-page-discounts]').innerHTML=(cart.cart_level_discount_applications||[]).map(d=>`<p class="fm-savings">${esc(d.title)} −${esc(money(d.total_allocated_amount))}</p>`).join('');
      const savings=page.querySelector('[data-cart-page-saving]');savings.hidden=!cart.total_discount;savings.querySelector('span').textContent=money(cart.total_discount);
      const shipping=shippingState(cart,page),panel=page.querySelector('[data-cart-page-shipping]');panel.hidden=!shipping;
      if(shipping){panel.querySelector('p').textContent=shipping.text;panel.querySelector('.fm-progress span').style.width=shipping.percent+'%';}
    });
  }
  function setupCart() {
    dialog = document.getElementById('fm-cart');
    cartBody = dialog.querySelector('[data-cart-body]');
    Object.assign(config.text, JSON.parse(dialog.querySelector('[data-cart-text]').textContent));
    dialog.addEventListener('close',()=>document.body.classList.remove('fm-modal-open'));
    dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
    const initial=dialog.querySelector('[data-cart-initial]');
    if(initial){const cart=JSON.parse(initial.textContent);latestCart=cart;updateCartRecommendations(cart);updateCartPage(cart);}
  }
  setupCart();
  function rememberCartFocus() {
    const active=document.activeElement;
    if(active?.dataset.cartChange)return {key:active.dataset.cartChange,action:active.dataset.cartAction,identity:active.dataset.cartIdentity,inDialog:dialog.contains(active)};
    if(active?.hasAttribute('data-cart-recommendation-add'))return {recommendation:active.dataset.quickAdd,inDialog:dialog.contains(active)};
    return null;
  }
  function restoreCartFocus(focus) {
    if(!focus)return;
    const scope=focus.inDialog?dialog:document.querySelector('[data-cart-page]');if(!scope)return;
    const target=focus.key?Array.from(scope.querySelectorAll('[data-cart-change]')).find(button=>(button.dataset.cartChange===focus.key||button.dataset.cartIdentity===focus.identity)&&button.dataset.cartAction===focus.action):Array.from(scope.querySelectorAll('[data-cart-recommendation-add]')).find(button=>button.dataset.quickAdd===focus.recommendation);
    const fallback=scope.querySelector('[data-cart-recommendations]:not([hidden]) h3')||scope.querySelector('[data-cart-change]')||scope.querySelector('[data-close-cart]')||scope.querySelector('[data-cart-page-empty]:not([hidden]) a')||scope.querySelector('h1');
    (target||fallback)?.focus({preventScroll:true});
  }
  function setCartBusy(busy) {
    cartBusy=busy;
    dialog.setAttribute('aria-busy',String(busy));
    document.querySelectorAll('#fm-cart [data-cart-body] button,[data-cart-recommendation-add],[data-cart-page-form] button').forEach(button=>{
      if(busy){if(!button.hasAttribute('data-cart-was-disabled'))button.dataset.cartWasDisabled=String(button.disabled);button.disabled=true;}
      else if(button.hasAttribute('data-cart-was-disabled')){button.disabled=button.dataset.cartWasDisabled==='true';delete button.dataset.cartWasDisabled;}
    });
  }
  async function syncPendingCartPage() {
    const pending=Array.from(document.querySelectorAll('[data-cart-page-key]')).filter(input=>input.value!==input.dataset.serverQuantity);
    if(!pending.length)return;
    const invalid=pending.find(input=>!input.checkValidity()||!Number.isInteger(Number(input.value))||Number(input.value)<0);
    if(invalid){invalid.reportValidity();throw new Error(t('error'));}
    const updates=Object.fromEntries(pending.map(input=>[input.dataset.cartPageKey,Number(input.value)]));
    const cart=await api('cart/update.js',{updates});
    pending.forEach(input=>input.dataset.serverQuantity=input.value);
    return cart;
  }
  function mutateCart(operation) {
    const next=cartQueue.catch(()=>{}).then(async()=>{
      const focus=rememberCartFocus();
      setCartBusy(true);dialog.querySelector('[data-cart-error]').textContent='';
      try{const syncedCart=await syncPendingCartPage();return await operation(syncedCart);}finally{setCartBusy(false);restoreCartFocus(focus);}
    });
    cartQueue=next;return next;
  }
  function renderCart(cart) {
    latestCart=cart;
    document.querySelectorAll('fm-product-picker, fm-bundle').forEach(picker=>{if(picker.ready)picker.render();});
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    updateCartRecommendations(cart);updateCartPage(cart);
    if(!cart.item_count) {cartBody.innerHTML=`<div class="fm-cart-empty"><p>${esc(t('empty'))}</p><a class="fm-button" href="${esc(route('collections/all'))}">${esc(t('discover'))} <span aria-hidden="true">↗</span></a></div>`;return;}
    const sprayCount=cart.items.filter(i=>!i.selling_plan_allocation&&config.sprayIds.includes(String(i.product_id))).reduce((sum,i)=>sum+i.quantity,0);
    const progress=sprayCount>=4?t('best'):t('next',{count:Math.max(1,Math.min(4,sprayCount+1)-sprayCount)});
    const shipping=shippingState(cart);
    cartBody.innerHTML=cartMixPanel(cart)+`${shipping?`<div class="fm-cart-shipping"><p>${esc(shipping.text)}</p><div class="fm-progress" aria-hidden="true"><span style="width:${shipping.percent}%"></span></div></div>`:''}`+cart.items.map(item=>cartLine(item)).join('')+`<div class="fm-cart-total">${(cart.cart_level_discount_applications||[]).map(d=>`<p class="fm-savings">${esc(d.title)} −${esc(money(d.total_allocated_amount))}</p>`).join('')}<div class="fm-bundle-total"><span>${esc(t('total'))}</span><strong>${esc(money(cart.total_price))}</strong></div>${cart.total_discount?`<p class="fm-savings">${esc(t('saving_label'))} ${esc(money(cart.total_discount))}</p>`:''}<p class="fm-unit">${esc(t('tax_shipping'))}</p><form action="${esc(route('cart'))}" method="post"><button type="submit" name="checkout" class="fm-button">${esc(t('checkout'))} <span aria-hidden="true">↗</span></button></form><a class="fm-text-link" href="${esc(route('cart'))}">${esc(t('view'))}</a></div>`;
  }
  async function openCart(cart) {
    dialog.querySelector('[data-cart-error]').textContent='';
    renderCart(cart || await api('cart.js'));
    if(!dialog.open)dialog.showModal();
    document.body.classList.add('fm-modal-open');
  }
  async function addItems(items) {
    return mutateCart(async()=>{
      await api('cart/add.js',{items});
      const cart=await api('cart.js');
      await openCart(cart);return cart;
    });
  }
  document.addEventListener('click',e=>{const button=e.target.closest('[data-swipe-direction]');if(!button)return;const rail=button.closest('.fm-swipe-wrap').querySelector('.fm-swipe');const card=rail.firstElementChild;if(!card)return;const gap=parseFloat(getComputedStyle(rail).columnGap)||0;rail.scrollBy({left:Number(button.dataset.swipeDirection)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});});
  document.addEventListener('click',async e=>{
    const open=e.target.closest('[data-open-cart]');
    if(open){e.preventDefault();try{await openCart();}catch{location.href=route('cart');}return;}
    if(e.target.closest('[data-close-cart]')){dialog.close();return;}
    const change=e.target.closest('[data-cart-change]');
    if(change){
      if(cartBusy)return;
      try{await mutateCart(async syncedCart=>{
        const item=syncedCart?.items.find(item=>item.key===change.dataset.cartChange)||syncedCart?.items.find(item=>cartIdentity(item)===change.dataset.cartIdentity);
        if(syncedCart&&!item){renderCart(syncedCart);return;}
        const quantity=item?(change.dataset.cartAction==='remove'?0:Math.max(0,item.quantity+(change.dataset.cartAction==='more'?1:-1))):Number(change.dataset.quantity);
        renderCart(await api('cart/change.js',{id:item?.key||change.dataset.cartChange,quantity}));
      });}
      catch(error){dialog.querySelector('[data-cart-error]').textContent=error.message;try{renderCart(await api('cart.js'));}catch{}if(!dialog.open){dialog.showModal();document.body.classList.add('fm-modal-open');}}
      return;
    }
    const quick=e.target.closest('[data-quick-add]');
    if(quick){
      if(quick.disabled||cartBusy)return;
      const recommendation=quick.closest('[data-cart-recommendations]');
      if(recommendation)recommendation.querySelector('[data-cart-recommendation-error]').textContent='';
      if(!recommendation)quick.disabled=true;
      try{await addItems([{id:quick.dataset.quickAdd,quantity:1}]);}
      catch(error){
        if(recommendation){recommendation.querySelector('[data-cart-recommendation-error]').textContent=error.message;dialog.querySelector('[data-cart-error]').textContent=error.message;}
        else{const toast=document.querySelector('.fm-toast');toast.textContent=error.message;toast.hidden=false;setTimeout(()=>toast.hidden=true,5000);}
      }
      finally{if(!recommendation)quick.disabled=false;}
      return;
    }
    const photo=e.target.closest('[data-image-src]');
    if(photo){const gallery=photo.closest('.fm-product-gallery');const main=gallery.querySelector('.fm-product-main-image img');main.src=photo.dataset.imageSrc;main.removeAttribute('srcset');main.alt=photo.dataset.imageAlt;gallery.querySelectorAll('[data-image-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===photo)));return;}
    if(e.target.closest('.fm-mobile-menu nav a'))e.target.closest('.fm-mobile-menu').removeAttribute('open');
  });
  function updateProductQuantity(form) {
    const input=form.querySelector('[data-product-quantity]');
    if(!input.checkValidity())return;
    const quantity=Number(input.value);const tier=Math.min(quantity,4);
    const rates=Array.from(form.querySelectorAll('[name="fm-quantity"]'));
    rates.forEach(radio=>radio.checked=Number(radio.value)===tier);
    const base=Number(rates[0].dataset.unitPrice);const price=Number(rates[tier-1].dataset.unitPrice);
    form.querySelector('[data-product-total]').textContent=money(price*quantity);
    form.querySelector('[data-product-saving]').textContent=quantity>1?t('savings',{amount:money((base-price)*quantity)}):'';
    form.querySelector('[data-product-minus]').disabled=quantity<=1;
  }
  document.addEventListener('change',e=>{
    if(e.target.matches('[name="fm-quantity"]')){
      const form=e.target.closest('form');form.querySelector('[data-product-quantity]').value=e.target.value;updateProductQuantity(form);
    }
    if(e.target.matches('[data-product-quantity]'))updateProductQuantity(e.target.closest('form'));
  });
  document.addEventListener('input',e=>{if(e.target.matches('[data-product-quantity]'))updateProductQuantity(e.target.closest('form'));});
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-product-minus],[data-product-plus]');if(!button||button.disabled)return;
    const form=button.closest('form');const input=form.querySelector('[data-product-quantity]');
    input.value=Math.max(1,(Number(input.value)||0)+(button.hasAttribute('data-product-plus')?1:-1));updateProductQuantity(form);
  });
  document.addEventListener('submit',async e=>{
    if(!e.target.matches('.fm-product-form'))return;
    e.preventDefault();const form=e.target;const btn=form.querySelector('button[type="submit"]');if(btn.disabled)return;
    btn.disabled=true;const err=form.querySelector('.fm-error');err.textContent='';
    try{await addItems([{id:form.querySelector('[name="id"]').value,quantity:Number(form.querySelector('[name="quantity"]').value)}]);}
    catch(error){err.textContent=error.message;}
    finally{btn.disabled=false;}
  });
  class FemoraProductPicker extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.pending=false;this.customSelection=false;
      this.cards=Array.from(this.querySelectorAll('[data-mix-card]'));
      this.prices=[0,...[1,2,3,4].map(n=>Math.round(Number((this.dataset['price'+n]||'').replace(',','.'))*100))];
      this.current=this.cards.find(card=>card.dataset.variant===this.dataset.initialVariant)||this.cards[0];
      this.selected=Object.fromEntries(this.cards.map(card=>[card.dataset.variant,Number(card.querySelector('[data-mix-quantity]').value)]));
      this.addEventListener('click',event=>{
        const adjust=event.target.closest('[data-mix-plus],[data-mix-minus]');
        if(adjust){
          if(this.pending||adjust.disabled)return;
          const card=adjust.closest('[data-mix-card]');this.customSelection=true;
          this.selected[card.dataset.variant]=Math.min(99,Math.max(0,(this.selected[card.dataset.variant]||0)+(adjust.hasAttribute('data-mix-plus')?1:-1)));
          if(card!==this.current)this.view(card);else this.render();return;
        }
        const button=event.target.closest('[data-mix-preview]');
        if(!button||this.pending)return;
        const card=button.closest('[data-mix-card]');
        if(card!==this.current){
          if(!this.customSelection){this.cards.forEach(item=>this.selected[item.dataset.variant]=item===card&&item.dataset.available==='true'?1:0);}
          this.view(card);
        }
      });
      this.addEventListener('input',event=>{
        if(!event.target.matches('[data-mix-quantity]')||this.pending)return;
        const input=event.target,card=input.closest('[data-mix-card]');this.customSelection=true;
        this.selected[card.dataset.variant]=Math.min(99,Math.max(0,Math.floor(Number(input.value)||0)));
        this.render();
      });
      this.addEventListener('submit',event=>{if(!event.target.matches('.fm-product-single-form'))return;event.preventDefault();this.submit();});
      this.render();
    }
    view(card){
      this.current=card;
      document.querySelectorAll('[data-scent-notes]').forEach(el=>el.hidden=el.dataset.scentNotes!==card.dataset.product);
      this.querySelector('[data-mix-title]').textContent=card.dataset.title;
      this.querySelector('[data-mix-focus-price]').textContent=money(Number(card.dataset.price));
      const reference=this.querySelector('[data-mix-reference]');if(reference)reference.hidden=Number(reference.dataset.referenceCents)<=Number(card.dataset.price);
      this.querySelectorAll('[data-mix-detail-title]').forEach(el=>el.textContent=card.dataset.title);
      this.querySelector('[data-mix-unit]').textContent=money(Math.round(Number(card.dataset.price)*1000/Number(this.dataset.volume)))+' '+t('per_litre');
      this.querySelector('[data-mix-gallery]').replaceChildren(card.querySelector('[data-mix-gallery-template]').content.cloneNode(true));
      const description=this.querySelector('[data-mix-description]');
      description.replaceChildren(card.querySelector('[data-mix-description-template]').content.cloneNode(true));
      this.querySelector('[data-mix-details]').hidden=!description.textContent.trim();
      this.querySelector('[data-mix-story]').replaceChildren(card.querySelector('[data-mix-story-template]').content.cloneNode(true));
      const profile=this.querySelector('[data-mix-profile]');profile.replaceChildren(card.querySelector('[data-mix-profile-template]').content.cloneNode(true));profile.hidden=!profile.children.length;
      this.querySelector('[data-mix-error]').textContent='';this.render();
    }
    render(){
      const available=this.current?.dataset.available==='true';
      const selected=this.cards.filter(card=>(this.selected[card.dataset.variant]||0)>0&&card.dataset.available==='true');
      const count=selected.reduce((sum,card)=>sum+this.selected[card.dataset.variant],0);
      this.cards.forEach(card=>{
        const active=card===this.current,quantity=this.selected[card.dataset.variant]||0,available=card.dataset.available==='true';
        card.classList.toggle('is-viewed',active);card.classList.toggle('has-quantity',quantity>0);
        const button=card.querySelector('[data-mix-preview]');button.setAttribute('aria-pressed',String(active));button.disabled=this.pending;
        const input=card.querySelector('[data-mix-quantity]');input.value=quantity;input.disabled=this.pending||!available;
        card.querySelector('[data-mix-minus]').disabled=this.pending||quantity===0;
        card.querySelector('[data-mix-plus]').disabled=this.pending||!available||quantity>=99;
      });
      this.querySelector('[data-single-variant]').value=this.current?.dataset.variant||'';
      this.querySelector('[data-mix-submit]').disabled=this.pending||count===0;
      this.querySelector('[data-single-button-text]').textContent=this.pending?t('loading'):count?this.dataset.buttonLabel:this.dataset.emptyLabel;
      this.querySelector('[data-mix-count]').textContent=this.dataset.selectionLabel.replace('[count]',String(count));
      const already=(latestCart.items||[]).filter(item=>!item.selling_plan_allocation&&config.sprayIds.includes(String(item.product_id))).reduce((sum,item)=>sum+item.quantity,0);
      const tierEligible=config.currency==='EUR'&&selected.every(card=>Number(card.dataset.price)===this.prices[1])&&this.prices.slice(1).every(price=>price>0);
      const total=tierEligible?count*this.prices[Math.min(4,count+already)]:selected.reduce((sum,card)=>sum+Number(card.dataset.price)*this.selected[card.dataset.variant],0);
      const amount=this.querySelector('[data-mix-button-price]');amount.textContent=money(total||0);amount.hidden=count===0||this.pending;
      const regularTotal=selected.reduce((sum,card)=>sum+Number(card.dataset.price)*this.selected[card.dataset.variant],0);
      const savings=Math.max(0,regularTotal-total),summary=this.querySelector('[data-mix-price-summary]');
      if(summary){
        summary.hidden=count===0||savings===0;
        this.querySelector('[data-mix-regular-total]').textContent=money(regularTotal);
        this.querySelector('[data-mix-discount-total]').textContent=money(total);
        const each=this.querySelector('[data-mix-price-each]'),saving=this.querySelector('[data-mix-saving]');
        each.textContent=count?money(Math.round(total/count))+' '+each.dataset.label:'';
        this.querySelector('[data-mix-selected-unit]').textContent=count?money(Math.round(total/count*1000/30))+' / l · inkl. MwSt.':'';
        saving.textContent=saving.dataset.label.replace('[amount]',money(savings));
      }
      const tray=this.querySelector('[data-mix-selection]');tray.replaceChildren();
      selected.forEach(card=>{
        const chip=document.createElement('span');chip.className='fm-selected-scent';chip.style.setProperty('--scent-tint',card.style.getPropertyValue('--scent-tint'));
        const original=card.querySelector('.fm-single-scent-image img');if(original){const photo=original.cloneNode();photo.alt='';photo.width=28;photo.height=28;photo.sizes='28px';chip.append(photo);}
        const text=document.createElement('span');text.textContent=card.dataset.title;const qty=document.createElement('b');qty.textContent='×'+this.selected[card.dataset.variant];chip.append(text,qty);tray.append(chip);
      });
      if(!count)tray.textContent=this.dataset.emptySelection;
      const delivery=this.querySelector('[data-mix-delivery]');if(delivery)delivery.hidden=!available;
      this.setAttribute('aria-busy',String(this.pending));
    }
    async submit(){
      if(this.pending)return;
      const items=this.cards.filter(card=>card.dataset.available==='true'&&(this.selected[card.dataset.variant]||0)>0).map(card=>({id:card.dataset.variant,quantity:this.selected[card.dataset.variant]}));
      if(!items.length)return;
      this.pending=true;const error=this.querySelector('[data-mix-error]');error.textContent='';this.render();
      try{await addItems(items);}catch(err){error.textContent=err.message;}finally{this.pending=false;this.render();}
    }
  }
  if(!customElements.get('fm-product-picker'))customElements.define('fm-product-picker',FemoraProductPicker);
  class FemoraBundle extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.selected={};this.pending=false;
      this.cards=Array.from(this.querySelectorAll('[data-variant]'));
      this.prices=[0,...[1,2,3,4].map(n=>Math.round(Number(this.dataset['price'+n].replace(',','.'))*100))];
      this.shippingThreshold=Math.round(Number(this.dataset.shippingThreshold.replace(',','.'))*100);
      this.addEventListener('click',e=>{
        const add=e.target.closest('[data-bundle-plus]');const minus=e.target.closest('[data-bundle-minus]');const remove=e.target.closest('[data-bundle-remove]');
        if(add||minus||remove){
          const button=add||minus||remove;if(button.disabled||this.pending)return;
          const key=remove?remove.dataset.bundleRemove:button.closest('[data-variant]').dataset.variant;
          this.selected[key]=Math.max(0,(this.selected[key]||0)+(add?1:-1));
          this.querySelector('[data-bundle-error]').textContent='';this.render();
          if(remove){const next=Array.from(this.querySelectorAll('[data-bundle-remove]')).find(b=>b.dataset.bundleRemove===key);(next||this.cards.find(card=>card.dataset.variant===key).querySelector('[data-bundle-plus]')).focus({preventScroll:true});}
          return;
        }
        if(e.target.closest('[data-bundle-submit]'))this.submit();
      });this.render();
    }
    count(){return Object.values(this.selected).reduce((s,n)=>s+n,0);}
    template(value,vars){return Object.entries(vars).reduce((text,[key,val])=>text.replaceAll('['+key+']',String(val)),value||'');}
    render(){
      const count=this.count();const already=(latestCart.items||[]).filter(item=>!item.selling_plan_allocation&&config.sprayIds.includes(String(item.product_id))).reduce((sum,item)=>sum+item.quantity,0);const combined=count+already;const tier=Math.min(combined,4);const unit=count?this.prices[tier]:0;const total=unit*count;const original=this.prices[1]*count;const savings=Math.max(0,original-total);
      this.querySelector('[data-bundle-summary]').hidden=count===0;
      this.querySelector('[data-bundle-summary-title]').textContent=count?this.template(this.dataset.titleTemplate,{count}):this.dataset.emptyTitle;
      this.querySelector('[data-bundle-count]').textContent=this.template(this.dataset.countTemplate,{count});
      this.querySelector('[data-bundle-each]').textContent=count?money(unit)+' '+this.dataset.perSpray:'';
      this.querySelector('[data-bundle-total]').textContent=money(total);
      this.querySelector('[data-bundle-original]').textContent=savings?money(original):'';
      this.querySelector('[data-bundle-savings]').textContent=savings?this.template(this.dataset.savingsTemplate,{amount:money(savings)}):'';
      this.querySelector('[data-bundle-unit]').textContent=count?money(Math.round(unit/30*1000))+' '+t('per_litre'):'';
      this.querySelector('[data-bundle-submit]').disabled=count===0||this.pending;
      this.setAttribute('aria-busy',String(this.pending));
      const progressText=count===0?this.dataset.emptyText:combined>=4?this.template(this.dataset.progressBest,{price:money(this.prices[4])}):this.template(this.dataset.progressTemplate,{remaining:1,price:money(this.prices[combined+1])});
      const stageText=this.dataset['stage'+tier]||progressText;
      this.querySelector('[data-bundle-progress-message]').textContent=stageText;
      this.querySelector('[data-bundle-fill]').style.width=Math.min(combined/4*100,100)+'%';
      const progress=this.querySelector('[data-bundle-progress]');progress.setAttribute('aria-valuenow',String(tier));progress.setAttribute('aria-valuetext',stageText);
      this.querySelectorAll('[data-bundle-tier]').forEach(el=>{const step=Number(el.dataset.bundleTier);const active=step===tier;el.classList.toggle('is-active',active);el.classList.toggle('is-reached',combined>=step);if(active)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');});
      const slots=[];let selectedAvailable=true;
      this.cards.forEach(card=>{
        const key=card.dataset.variant;const qty=this.selected[key]||0;const available=card.dataset.available==='true';
        card.classList.toggle('is-selected',qty>0);card.querySelector('output').textContent=qty;card.querySelector('[data-bundle-minus]').disabled=qty===0||this.pending;
        card.querySelectorAll('[data-bundle-plus]').forEach(button=>button.disabled=!available||this.pending);
        if(qty){
          selectedAvailable=selectedAvailable&&available;
          const picture=card.dataset.image?`<img src="${esc(card.dataset.image)}" alt="" width="58" height="58">`:'<span class="fm-set-pick-symbol" aria-hidden="true">✧</span>';
          slots.push(`<div class="fm-set-pick"><div class="fm-set-pick-image">${picture}<span class="fm-set-pick-qty">×${qty}</span><button type="button" class="fm-set-pick-remove" data-bundle-remove="${esc(key)}" aria-label="${esc(this.template(this.dataset.removeTemplate,{title:card.dataset.title}))}" ${this.pending?'disabled':''}>×</button></div><span class="fm-set-pick-name">${esc(card.dataset.title)}</span></div>`);
        }
      });
      this.querySelector('[data-bundle-slots]').innerHTML=slots.join('');
      const delivery=this.querySelector('[data-bundle-delivery]');if(delivery)delivery.hidden=count>0?!selectedAvailable:!this.cards.some(card=>card.dataset.available==='true');
      const shipping=this.querySelector('[data-bundle-shipping]');shipping.hidden=count===0;
      const projectedCart=total+already*(this.prices[tier]||this.prices[1])+(latestCart.items||[]).filter(item=>item.selling_plan_allocation||!config.sprayIds.includes(String(item.product_id))).reduce((sum,item)=>sum+item.final_line_price,0);
      shipping.textContent=projectedCart>=this.shippingThreshold?this.dataset.shippingUnlocked:this.template(this.dataset.shippingRemaining,{amount:money(this.shippingThreshold-projectedCart)});
    }
    async submit(){
      if(this.pending||this.count()===0)return;this.pending=true;this.render();const err=this.querySelector('[data-bundle-error]');err.textContent='';
      try{
        const items=Object.entries(this.selected).filter(([id,q])=>q>0).map(([id,quantity])=>({id,quantity}));
        for(const item of items){const card=this.cards.find(c=>c.dataset.variant===item.id);if(Number(card.dataset.base)!==this.prices[1])throw new Error(t('price_changed'));}
        await addItems(items);this.selected={};
      }catch(error){err.textContent=error.message;}finally{this.pending=false;this.render();}
    }
  }
  if(!customElements.get('fm-bundle'))customElements.define('fm-bundle',FemoraBundle);
  document.addEventListener('shopify:section:load',()=>{if(document.getElementById('fm-cart')!==dialog)setupCart();document.querySelectorAll('fm-bundle').forEach(el=>el.connectedCallback());});
})();
  } catch(e) { console.error(e); }
})();

})();
